import React from 'react'
import styles from './CardBody.scss'
import { urls } from 'lib/urls'
import PropTypes from 'prop-types'

export class CardBody extends React.PureComponent {
  render () {
    const { header, image, content } = this.props
    return (
      <div className={styles.body}>
        {header && <div className={styles.header}>{header}</div>}
        {image}
        {content && <div className={styles.content}>
          {content}
        </div>}
      </div>
    )
  }
}

export const HoverPreviewImage = ({ type, id }) => (
  <img className={styles.previewImgContainer}
    src={urls.staticMap(type, 'hover_preview', id)}
    srcSet={`${urls.staticMap(type, 'hover_preview', id)} 1x, ${urls.staticMap(type, 'hover_preview@2x', id)} 2x`} />
)

HoverPreviewImage.propTypes = {
  type: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
}

export const Metrics = ({ children }) => <div className={styles.metrics}>
  {children}
</div>

export const Metric = ({ label, value }) => <div className={styles.metric}>
  <div className={styles.value}>{value}</div>
  <div className={styles.label}>{label}</div>
</div>
